function directive() {
    return {
        link: function ($scope, element) {
            $scope.$on('iocDesc', function (event, description) {
                if (!description) { return }
                    var maxLength = 160;
                // if the string is less then our max length..
                if (description.length < maxLength) {
                    $(element).html(description);
                // otherwise, trim and add link to modal
                // NOTE: MODAL SETTINGS ARE CUSTOM IN EACH CONTROLLER
                } else {
                    var subString = description.substring(0, maxLength);
                    $(element).html(subString+'... <a href="javascript:void(0);"><strong>Read More</strong></a>');
                    $(element).on('click', function () {
                        $scope.description(description);
                    });
                }
            });
            $scope.$on('$destroy', function () {
                element.remove();
            });
        }
    };
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/iocdesc/iocdesc.js
 **/